import { RootState } from "../store/community-finder-redux-store";

export const selectRerenderMap = (state: RootState) =>
	state?.appStatus?.reRenderMap;
